export enum EPhoneVerificationStep {
  PHONE,
  VERIFY,
}
